var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-slot',{attrs:{"title":_vm.titleRemove,"is-cancel-hide":!_vm.isClose,"cancel-text":_vm.textRemoveClose,"is-save":_vm.isSave,"apply-text":_vm.textRemoveSave,"width":_vm.width},on:{"updateClose":_vm.onClose,"updateSave":_vm.onSave}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.textRemove)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }